import { useContext } from 'react';

import FilterFormContext from './FilterFormContext';
import { FilterFormContextProps } from './FilterForm.types';

const useFilterFormContext = <T>() => {
  const context = useContext<FilterFormContextProps<T> | undefined>(
    FilterFormContext,
  );

  if (!context) {
    throw new Error(
      'Component must be wrapped in the FilterFormContextProvider.',
    );
  }

  return context;
};

export default useFilterFormContext;
